import { Component } from "react";

import './style.scss';

class RectButton extends Component {    

    render() {
        let { text, icon, bgColor } = this.props;
        return (
            <>                
                <div className={`${this.props.className || ""} ${this.props.disabled ? "disabled" : ""}  rect-bt ${this.props.transparentBgHover ? "transparent-bg-hover" : ""} ${this.props.noTextHover ? "no-text-hover" : ""}`} style={{backgroundColor: bgColor, borderColor: bgColor}} onClick={this.props.onClick}>{icon ? icon : null}<span>{text}</span>{this.props.children}</div>
            </>
        )
    }
}

export default RectButton;